import React from 'react';

import List, {ListItem, ListItemSecondaryAction, ListItemText, ListItemIcon } from 'material-ui/List';
import Button from 'material-ui/Button';
import Avatar from 'material-ui/Avatar';
import { Edit, CheckCircle, Cancel, Home, Work} from 'material-ui-icons';
import Divider from 'material-ui/Divider';

import Grid from 'material-ui/Grid';

import moment from 'moment-timezone';
import axios from 'axios';

import tsl from './../../../tsl';
import { getWeightUnit } from 'utils/client';

export default class BookingItem extends React.Component {
	
    getUpdatePassengersLink = (uuid) => {
        return axios.defaults.baseURL + 'booking/'+uuid;
    };

	render() {
		const booking = this.props.booking;
        const nBookings = this.props.nBookings || null;
		const otherPassengersInfo = (booking.passengers.length > 1 
                ? ' (+' + (booking.passengers.length-1) + ')'
                : '');

        const bookingToPay = parseFloat(booking.to_pay).toFixed(2)+' '+booking.currency_code;
        const bookingPaidVoucher = parseFloat(booking.paid_by_voucher).toFixed(2)+' '+booking.currency_code;
        const bookingSum = (parseFloat(booking.price) - parseFloat(booking.paid_by_voucher)).toFixed(2)+' '+booking.currency_code;

        return (
            <div>
                <ListItem>
                    <Grid container spacing={0}>
                        <Grid item sm={6} xs={12}>
                            <ListItemText
                                primary={`#${booking.id} ` + booking.first_name + ' ' + booking.last_name + otherPassengersInfo}
                                secondary={booking.phone + ', ' + booking.email}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <ListItemText
                                primary={
                                  <span>{
                                  booking.paid_at
                                    ? tsl('booking.is_paid', { sum: bookingSum })
                                    : tsl('booking.to_pay', { sum: bookingToPay })
                                  } {booking.payment_type && booking.payment_type.name != 'VOUCHER' ? booking.payment_type.title : ''}</span>
                                }
                                secondary={booking.paid_by_voucher ?
                                  <div>
                                    {tsl('booking.paid_by_voucher', { sum: bookingPaidVoucher })}<br />
                                    {booking.voucher_used && tsl('booking.paid_by_voucher_code', booking.voucher_used)}
                                  </div> : ''}
                            />
                            {booking.is_exclusive && this.props.nBookings > 1 &&
                                <div>
                                    {' '} <img src="./assets/images/mas-cashback.png" width={20} alt="cashback" title="cashback"/>
                                </div>
                            }
                        </Grid>
                    </Grid>
                    {(this.props.viewOnly || booking.is_exclusive) ? null :
                        <ListItemSecondaryAction>
                            <Button onClick={this.props.onChangeClick} className="jr-btn">
                                <i className="zmdi zmdi-swap zmdi-hc-2x"/>
                            </Button>
                        </ListItemSecondaryAction>
                    }
                </ListItem>
                {!booking.note ? null :
                    <ListItem>
                        <ListItemText secondary={
                            <span>
                                <i className="zmdi zmdi-quote" />
                                {' ' + booking.note}
                            </span>}
                        />
                    </ListItem>
                }
                {
                  (booking.carry_on_count || booking.suitcase_count) ?
                  <ListItem>
                      <ListItemIcon>
                          <Work />
                      </ListItemIcon>
                      <ListItemText
                          primary={tsl('booking.luggage_info', booking)}
                      />
                  </ListItem> : null
                }
                <ListItem>
                    <ListItemIcon>
                        <Home />
                    </ListItemIcon>
                    <ListItemText
                        primary={booking.address &&
                        <span>
                          {booking.address.street}, {booking.address.zip_code} {booking.address.city}, {booking.address.state ? `${booking.address.state}, `: ''} {booking.address.country}
                        </span>
                        }
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                      {booking.check_insurance_info ? <CheckCircle style={{color: 'green'}} /> : <Cancel style={{color: 'red'}} />}
                    </ListItemIcon>
                    <ListItemText
                        primary={tsl('booking.check_insurance_info.title')}
                        secondary={booking.check_insurance_info ? moment(booking.check_insurance_info).format('LLL') : null}
                    />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        {booking.check_safety_info ? <CheckCircle style={{color: 'green'}} /> : <Cancel style={{color: 'red'}} />}
                    </ListItemIcon>
                    <ListItemText
                        primary={tsl('booking.check_safety_info.title')}
                        secondary={booking.check_safety_info ? moment(booking.check_safety_info).format('LLL') : null}
                    />
                </ListItem>
                <List dense={true}>
                {booking.passengers.map(passenger => {
                    return (
                        <ListItem key={passenger.id}>
                            <ListItemText
                                primary={
                                    <span>
                                        <i className="zmdi zmdi-account"></i>
                                        {' ' + (passenger.first_name || passenger.last_name ? passenger.first_name+' '+passenger.last_name : '-')
                                        + ' (' + (passenger.weight ? passenger.weight : '- ') + getWeightUnit() + ')'}
                                    </span>
                                }
                            />
                            {this.props.viewOnly ? null :
                                <Button href={this.getUpdatePassengersLink(booking.uuid)} target="_blank"><i className="zmdi zmdi-edit"/></Button>
                            }
                        </ListItem>
                    );
                })}
                </List>
                <Divider light />
            </div>
        );
	}
}


// WEBPACK FOOTER //
// ./app/used/flights/routes/BookingItem.js